// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { JoinCallIdentityKind } from 'components/JoinCallButton';

export type NewAcsMeetingDetails = {
  threadId: string;
  groupId: string;
  url: string;
  joinIdentity: JoinCallIdentityKind;
};

export const createNewACSMeeting = async (
  functionsAppToken: string,
  topic = 'ACS Selfhost Meeting'
): Promise<NewAcsMeetingDetails> => {
  const createACSMeetingQuery = 'api/createMeeting?topic=' + topic;

  const createMeetingReponse = await fetch(createACSMeetingQuery, {
    headers: new Headers({
      Authorization: `Bearer ${functionsAppToken}`
    })
  });

  if (!createMeetingReponse.ok) {
    throw new Error(
      `An error occurs when creating the new ACS meeting with ${createMeetingReponse.status} status code`
    );
  }

  return await createMeetingReponse.json();
};
